module.exports = __webpack_public_path__ + "static/media/Futura_Condensed_Bd.52110e79.woff";